export default "__VITE_ASSET__DtP6VT0F__"